import type { Material } from "@/types";
import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const getMaterials = async (): Promise<ServiceResponse<Material[]>> => {
  const response =
    await privateAPI.get<ServiceResponse<Material[]>>("/materials");
  return response.data;
};

export const getMaterial = async (materialId?: string): Promise<Material> => {
  const response = await privateAPI.get<ServiceResponse<Material>>(
    `/materials/${materialId}`,
  );
  return response.data.data;
};

export const addMaterial = async (
  material: Partial<Material>,
): Promise<Material> => {
  const response = await privateAPI.post<ServiceResponse<Material>>(
    `/materials`,
    material,
  );
  return response.data.data;
};

export const updateMaterial = async ({
  materialId,
  material,
}: {
  materialId: Material["id"];
  material: Partial<Material>;
}): Promise<Material> => {
  const response = await privateAPI.put<ServiceResponse<Material>>(
    `/materials/${materialId}`,
    material,
  );
  return response.data.data;
};

export const deleteMaterial = async (
  materialId: Material["id"],
): Promise<void> => {
  await privateAPI.delete(`/materials/${materialId}`);
};
